import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  createPurity,
  findAllActivePurity,
  getAllPurity,
  getPurityById,
  updatePurity,
} from "./services/purity.services";
import { clearPurityDetails, closePurityDrawerOpen } from "./puritySlice";
import { Typography } from "@progress/kendo-react-common";

const CreatePurity: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  // const PriorityList = useAppSelector((state) => state.priority.PriorityList);
  const PurityDetail = useAppSelector((state) => state.purity.PurityDetail);
  const purity_guid = useAppSelector((state) => state.muidrawer.data);
  const formLoading = useAppSelector((state) => state.purity.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const purityDrawerOpen = useAppSelector(
    (state) => state.purity.purityDrawerOpen
  );
  useEffect(() => {
    return () => {
      dispatch(clearPurityDetails());
      if (purityDrawerOpen) {
        dispatch(closePurityDrawerOpen());
      } else {
        dispatch(closed());
      }
    };
  }, []);

  useEffect(() => {
    if (purity_guid) {
      dispatch(getPurityById(purity_guid));
    }
  }, [purity_guid]);

  /* This Function calls when Form submit button Clicked */
  const handleSubmit = async (values: any) => {
    try {
      if (!purity_guid) {
        const InsertPayload = {
          purity: values.purity ? +values.purity : null,
          Carat: values.Carat ? values.Carat : "",
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createPurity(InsertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (purityDrawerOpen) {
            dispatch(closePurityDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearPurityDetails());
          isIndirect || purityDrawerOpen
            ? dispatch(findAllActivePurity())
            : dispatch(getAllPurity());
        }
      } else {
        const editPayload = {
          purity_guid: purity_guid,
          purity: values.purity ? +values.purity : null,
          Carat: values.Carat ? values.Carat : "",
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updatePurity(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (purityDrawerOpen) {
            dispatch(closePurityDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearPurityDetails());
          isIndirect || purityDrawerOpen
            ? dispatch(findAllActivePurity())
            : dispatch(getAllPurity());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    if (purityDrawerOpen) {
      dispatch(closePurityDrawerOpen());
    } else {
      dispatch(closed());
    }
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={PurityDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              <Typography.h4 className="m-0">
                {purity_guid ? "Update Purity" : "Add Purity"}
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Carat"
                label="Carat"
                placeholder="i.e. 24 CT"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="purity"
                label="Purity"
                placeholder="i.e. 99.99"
                type="number"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"isactive"}
                component={FormSelectionField}
                label={"Status"}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={purity_guid ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreatePurity;
